export default __webpack_public_path__ + "static/media/yen.077fe751.jpeg";